const PAYMENT_METHODS_ASSETS_BASE = 'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/payment-methods';
const ACH_BANK_ICONS = {
  ARVEST: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_arvest.svg`,
  BANK_OF_AMERICA: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_bankofamerica.svg`,
  BANK_OF_THE_WEST: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_bankofthewest.svg`,
  BB_T: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_bb_t_bank.svg`,
  BBVA: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_bbva.svg`,
  BMO: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_bmo.svg`,
  CHARLES_SCHWAB: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_charles_schwab.svg`,
  CHASE: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_chase.svg`,
  CHEMICAL_BANK: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_chemical_bank.svg`,
  CITI: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_citi.svg`,
  CITIZENS_BANK: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_citizens_bank.svg`,
  COMERICA: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_comerica.svg`,
  FIDELITY: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_fidelity.svg`,
  FIFTH_THIRD: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_fifth_third.svg`,
  FIRST_CITIZENS: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_first_citizens.svg`,
  FIRST_NATIONAL_BANK: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_first_national_bank.svg`,
  HSBC: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_hsbc.svg`,
  HUNTINGTON: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_huntington.svg`,
  KEY: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_key.svg`,
  M_T: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_m_t.svg`,
  NAVY_FEDERAL: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_navy_federal.svg`,
  OZARKS: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_ozarks.svg`,
  PEOPLES_UNITED: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_people_united.svg`,
  PNC: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_pnc_bank.svg`,
  REGIONS: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_regions.svg`,
  SANTANDER: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_santander.svg`,
  SUN_TRUST: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_sun_trust.svg`,
  TCF: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_tcf.svg`,
  TD: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_td.svg`,
  UMPQUA: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_umpqua_bank.svg`,
  UNION_BANK: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_union_bank.svg`,
  USAA: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_usaa.svg`,
  US_BANK: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_usbank.svg`,
  WELLS_FARGO: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_wellsfargo.svg`,
  WOODFOREST: `${PAYMENT_METHODS_ASSETS_BASE}/icon_ach_woodforest.svg`
};
// Ordered most-specific → least-specific to avoid substring collisions
// (e.g. "Citizens" must be tested before "Citi", "Bank of the West" before
// generic "Bank"). The backend's bankName is free-form, so matching is
// case-insensitive and tolerant of punctuation/spacing.
const ACH_BANK_NAME_MATCHERS = [[/wells\s*fargo/i, ACH_BANK_ICONS.WELLS_FARGO], [/bank\s*of\s*the\s*west/i, ACH_BANK_ICONS.BANK_OF_THE_WEST], [/bank\s*of\s*america/i, ACH_BANK_ICONS.BANK_OF_AMERICA], [/(bank\s*of\s*the\s*)?ozarks/i, ACH_BANK_ICONS.OZARKS], [/charles\s*schwab|\bschwab\b/i, ACH_BANK_ICONS.CHARLES_SCHWAB], [/chemical\s*bank/i, ACH_BANK_ICONS.CHEMICAL_BANK], [/\bchase\b|jpmorgan/i, ACH_BANK_ICONS.CHASE], [/first\s*citizens/i, ACH_BANK_ICONS.FIRST_CITIZENS], [/citizens/i, ACH_BANK_ICONS.CITIZENS_BANK], [/\bciti(bank|group)?\b/i, ACH_BANK_ICONS.CITI], [/comerica/i, ACH_BANK_ICONS.COMERICA], [/fidelity/i, ACH_BANK_ICONS.FIDELITY], [/fifth\s*third|5\/3/i, ACH_BANK_ICONS.FIFTH_THIRD], [/first\s*national/i, ACH_BANK_ICONS.FIRST_NATIONAL_BANK], [/\bbmo\b|bank\s*of\s*montreal/i, ACH_BANK_ICONS.BMO], [/hsbc/i, ACH_BANK_ICONS.HSBC], [/huntington/i, ACH_BANK_ICONS.HUNTINGTON], [/key\s*bank|keybank/i, ACH_BANK_ICONS.KEY], [/\bm\s*&?\s*t\b/i, ACH_BANK_ICONS.M_T], [/navy\s*federal/i, ACH_BANK_ICONS.NAVY_FEDERAL], [/people'?s?\s*united/i, ACH_BANK_ICONS.PEOPLES_UNITED], [/\bpnc\b/i, ACH_BANK_ICONS.PNC], [/\bregions\b/i, ACH_BANK_ICONS.REGIONS], [/santander/i, ACH_BANK_ICONS.SANTANDER], [/sun\s*trust|suntrust/i, ACH_BANK_ICONS.SUN_TRUST], [/\btcf\b/i, ACH_BANK_ICONS.TCF], [/td\s*bank|toronto[-\s]*dominion|^\s*td\s*$/i, ACH_BANK_ICONS.TD], [/umpqua/i, ACH_BANK_ICONS.UMPQUA], [/union\s*bank/i, ACH_BANK_ICONS.UNION_BANK], [/\busaa\b/i, ACH_BANK_ICONS.USAA], [/\bu\.?\s*s\.?\s*bank\b|usbank/i, ACH_BANK_ICONS.US_BANK], [/woodforest/i, ACH_BANK_ICONS.WOODFOREST], [/arvest/i, ACH_BANK_ICONS.ARVEST], [/\bbb\s*&?\s*t\b/i, ACH_BANK_ICONS.BB_T], [/bbva/i, ACH_BANK_ICONS.BBVA]];
const getAchBankIcon = bankName => {
  if (!bankName) return null;
  for (const [pattern, url] of ACH_BANK_NAME_MATCHERS) {
    if (pattern.test(bankName)) return url;
  }
  return null;
};
const PAYMENT_ICONS = {
  ACH_ACCOUNT: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_ach.svg`,
  VISA: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_visa.svg`,
  MASTER_CARD: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_mastercard.svg`,
  MAESTRO: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_maestro.svg`,
  CIRRUS: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_cirrus.svg`,
  AMERICAN_EXPRESS: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_amex.svg`,
  DISCOVER: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_discover.svg`,
  CREDIT_CARD: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_credit_card.svg`,
  JCB: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_jcb.svg`,
  DINERS_CLUB: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_diners.svg`,
  UNION_PAY: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_union.svg`,
  CHECK: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_check.svg`,
  PAYPAL: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_paypal.svg`,
  WIRE_TRANSFER: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_wire.svg`,
  OTHER_PAYMENTS: `${PAYMENT_METHODS_ASSETS_BASE}/icon_payment_cash.svg`
};
const PAYMENT_METHOD_MAX_LENGTH = {
  SHORT: 'SHORT',
  MEDIUM: 'MEDIUM',
  FULL: 'FULL'
};
const CardType = {
  Visa: 'Visa',
  MasterCard: 'MasterCard',
  AmericanExpress: 'AmericanExpress',
  Discover: 'Discover',
  JCB: 'JCB',
  Maestro: 'Maestro',
  Cirrus: 'Cirrus',
  UnionPay: 'UnionPay',
  DinersClub: 'DinersClub',
  Unknown: 'Unknown'
};
const PaymentMethods = {
  Ach: 'Ach',
  CreditCard: 'CreditCard',
  WireTransfer: 'WireTransfer',
  Paypal: 'PayPal',
  Check: 'Check',
  Other: 'Other'
};
const VerificationMethod = {
  Instant: 'Instant',
  MicroDeposit: 'MicroDeposit'
};
const paymentMethodSubStringConverter = (
// Optional at both ends to match the body: the first thing it does is return
// `null` for a missing string, and callers pass fields the API marks optional.
string, length) => {
  if (!string) {
    return null;
  }
  // Difference of 3 characters to only use ... when necessary.
  if (length === PAYMENT_METHOD_MAX_LENGTH.SHORT) {
    if (string.length < 15) {
      return string;
    }
    return string.substring(0, 12).concat('...');
  } else if (length === PAYMENT_METHOD_MAX_LENGTH.MEDIUM) {
    if (string.length < 21) {
      return string;
    }
    return string.substring(0, 17).concat('...');
  }
  return string;
};
const getPaymentMethodName = ({
  paymentMethod,
  accountLastDigits,
  referenceNumber,
  bankName,
  otherPaymentType
}, lengthOfAccountName = PAYMENT_METHOD_MAX_LENGTH.MEDIUM) => {
  if (paymentMethod === PaymentMethods.Ach) {
    return accountLastDigits ? `${paymentMethodSubStringConverter(bankName, lengthOfAccountName) || 'Account'} Ending ${accountLastDigits}` : 'Add Bank Account';
  } else if (paymentMethod === PaymentMethods.Check) {
    return `Check #${referenceNumber}`;
  } else if (paymentMethod === PaymentMethods.CreditCard) {
    return `Card Ending ${accountLastDigits}`;
  } else if (paymentMethod === PaymentMethods.WireTransfer) {
    return `Wire Transfer #${referenceNumber}`;
  } else if (paymentMethod === PaymentMethods.Paypal) {
    return `Paypal Transfer #${referenceNumber}`;
  } else if (paymentMethod === PaymentMethods.Other) {
    return `${otherPaymentType || paymentMethod} ${referenceNumber ? ` #${referenceNumber}` : ''}`;
  }
};
const getPaymentMethodIcon = (paymentMethod = PaymentMethods.Ach, paymentMethodType) => {
  if (paymentMethod === PaymentMethods.Ach) {
    return getAchBankIcon(paymentMethodType) ?? PAYMENT_ICONS.ACH_ACCOUNT;
  } else if (paymentMethod === PaymentMethods.CreditCard) {
    switch (paymentMethodType) {
      case CardType.Visa:
        return PAYMENT_ICONS.VISA;
      case CardType.MasterCard:
        return PAYMENT_ICONS.MASTER_CARD;
      case CardType.Maestro:
        return PAYMENT_ICONS.MAESTRO;
      case CardType.Cirrus:
        return PAYMENT_ICONS.CIRRUS;
      case CardType.AmericanExpress:
        return PAYMENT_ICONS.AMERICAN_EXPRESS;
      case CardType.Discover:
        return PAYMENT_ICONS.DISCOVER;
      case CardType.JCB:
        return PAYMENT_ICONS.JCB;
      case CardType.UnionPay:
        return PAYMENT_ICONS.UNION_PAY;
      case CardType.DinersClub:
        return PAYMENT_ICONS.DINERS_CLUB;
      default:
        return PAYMENT_ICONS.CREDIT_CARD;
    }
  } else if (paymentMethod === PaymentMethods.WireTransfer) {
    return PAYMENT_ICONS.WIRE_TRANSFER;
  } else if (paymentMethod === PaymentMethods.Paypal) {
    return PAYMENT_ICONS.PAYPAL;
  } else if (paymentMethod === PaymentMethods.Check) {
    return PAYMENT_ICONS.CHECK;
  } else {
    return PAYMENT_ICONS.OTHER_PAYMENTS;
  }
};

export { ACH_BANK_ICONS, CardType, PAYMENT_ICONS, PAYMENT_METHOD_MAX_LENGTH, PaymentMethods, VerificationMethod, getAchBankIcon, getPaymentMethodIcon, getPaymentMethodName, paymentMethodSubStringConverter };
